import { useState, useEffect } from 'react';

const APPLE_DEVICE_PATTERN = /Macintosh|iPhone|iPad|iPod/;

export const useAppleDevice = () => {
  const [isAppleDevice, setIsAppleDevice] = useState<boolean | null>(null);

  useEffect(() => {
    setIsAppleDevice(APPLE_DEVICE_PATTERN.test(navigator.userAgent));
  }, []);

  return isAppleDevice;
};
